import { render } from "./HolidayRequestsView.vue?vue&type=template&id=f90b402a&ts=true"
import script from "./HolidayRequestsView.vue?vue&type=script&lang=ts"
export * from "./HolidayRequestsView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__